import { Box, Avatar } from '@mui/material'
import { AccessTimeOutlined } from '@mui/icons-material'
import {
  AvatarBox,
  ChatBubble,
  Dot,
  DotGroup,
  Header,
  Name,
  Row,
  Status,
  StatusDot,
  Timer,
  Wrapper,
} from './TypingIndicator.styles'

const TypingIndicator = ({ status, elapsedSeconds = 0 }) => {
  const brandColor = '#667eea'
  return (
    <Wrapper>
      {/* Avatar */}
      <AvatarBox>
        <Avatar sx={{ width: 36, height: 36, background: 'transparent' }}>
          <Box
            component="img"
            src="/logo.png"
            alt="F.R.A.N.C.A."
            sx={{ width: '100%', height: '100%' }}
          />
        </Avatar>
      </AvatarBox>

      {/* Bubble */}
      <ChatBubble>
        <Header>
          <Name variant="subtitle2">F.R.A.N.C.A.</Name>

          {elapsedSeconds > 0 && (
            <Timer>
              <AccessTimeOutlined fontSize="small" />
              <span>{Math.floor(elapsedSeconds)}s</span>
            </Timer>
          )}
        </Header>

        <Row>
          <DotGroup>
            {[0, 0.2, 0.4].map((delay, i) => (
              <Dot key={i} delay={delay} brandcolor={brandColor} />
            ))}
          </DotGroup>

          <Status variant="body2">
            {status || 'Elaborazione'}
            {[0, 0.2, 0.4].map((delay, i) => (
              <StatusDot key={i} delay={delay}>
                .
              </StatusDot>
            ))}
          </Status>
        </Row>
      </ChatBubble>
    </Wrapper>
  )
}

export default TypingIndicator
